import apiClient from "services/apiClient";

async function editObject(id: any, data: any) {
  const url = `/admin/objects/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editObject;